import LayoutConfigTypes from '@/core/config/LayoutConfigTypes'

const config: LayoutConfigTypes = {
  themeName: 'Metronic',
  themeVersion: '8.0.27',
  demo: 'demo1',
  main: {
    type: 'default',
    primaryColor: '#009EF7',
    logo: {
      dark: 'media/logos/must-logo.png',
      light: 'media/logos/must-logo.png',
    },
  },
  loader: {
    // logo: 'media/logos/logo-1-dark.svg',
    logo: 'media/logos/must-logo.png',
    display: true,
    type: 'default',
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: 'font',
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: true,
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  aside: {
    display: true,
    theme: 'light', //'light' //'dark'
    fixed: true,
    menuIcon: 'svg',
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: 'fluid',
  },
  footer: {
    width: 'fluid',
  },
  version: '0.0.1',
}

export default config
